import { Injectable, OnDestroy } from '@angular/core';
import { AbstractCRUDService } from '@campaign-portal/components-library';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { EntityField, InputType } from '@campaign-portal/namespace/common/entityField';
import { ReadResponse } from '@campaign-portal/namespace/common/implementations';
import { FilterType } from '@campaign-portal/namespace/common/rpc.params';

@Injectable({
	providedIn: 'root'
})
export class ImportRatesFieldsService implements AbstractCRUDService, OnDestroy {

	readonly Id: EntityField = {
		id: 0,
		name: 'import_rates.id',
		variable: 'id',
		filterType: FilterType.LIKE,
		required: false,
		type: InputType.TEXT
	};
	readonly Source: EntityField = {
		id: 1,
		name: 'import_rates.source',
		variable: 'provider',
		filterType: FilterType.LIKE,
		required: false,
		type: InputType.TEXT
	};
	readonly MCCMNC: EntityField = {
		id: 2,
		name: 'import_rates.mccmnc',
		variable: 'mccmnc',
		filterType: FilterType.LIKE,
		required: false,
		type: InputType.TEXT
	};
	readonly Rate: EntityField = {
		id: 3,
		name: 'import_rates.rate',
		variable: 'rate',
		filterType: FilterType.LIKE,
		required: false,
		type: InputType.TEXT
	};

	readonly entity = '';
	readonly title = '';
	readonly loading$ = new BehaviorSubject<boolean>(false);
	readonly headers: EntityField[] = [
		this.Id,
		this.Source,
		this.MCCMNC,
		this.Rate,
	];

	constructor() {
	}

	ngOnDestroy(): void {
		this.loading$.complete();
	}

	read(): Observable<ReadResponse<EntityField[]>> {
		return of({
			Success: true,
			Total: this.headers.length,
			Data: this.headers
		});

	}

	create(): Observable<void> {
		return of();
	}

	update(): Observable<void> {
		return of();
	}

	delete(): Observable<void> {
		return of();
	}
}
